import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { money } from "../lib/data";
import { useShop } from "../context/ShopContext";

export default function ProductCard({ product, index = 0 }) {
  const { addToCart } = useShop();
  const frame = product.wide ? "aspect-[4/3]" : "aspect-[4/5]";
  return (
    <motion.article
      data-testid={`product-card-${product.slug}`}
      className="group"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.4, delay: (index % 5) * 0.06, ease: "easeOut" }}
    >
      <Link to={`/product/${product.slug}`} data-testid={`product-link-${product.slug}`}
            className={`clip-card relative block ${frame} overflow-hidden bg-ll-coal`}>
        <div className="card-spotlight" aria-hidden="true" />
        <img src={product.images[0]} alt={product.name} loading="lazy"
             className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
        {product.images[1] && (
          <img src={product.images[1]} alt="" loading="lazy" aria-hidden="true"
               className="absolute inset-0 h-full w-full object-cover opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
        )}
        <span className="absolute left-3 top-3 bg-ll-black/85 px-2 py-0.5 font-tech text-[10px] tracking-[0.15em] text-ll-bone backdrop-blur-sm">
          {product.category.toUpperCase()}
        </span>
      </Link>
      <div className="mt-3 flex items-start justify-between gap-3">
        <Link to={`/product/${product.slug}`} className="transition-colors duration-200 hover:text-ll-red">
          <p className="font-display text-2xl leading-none tracking-wide">{product.name}</p>
          <p className="mt-1 font-tech text-sm text-ll-bone/60">{money(product.price)}</p>
        </Link>
        <motion.button
          data-testid={`add-to-cart-${product.slug}`}
          whileTap={{ scale: 0.95 }}
          onClick={() => addToCart(product)}
          className="ll-lift mt-1 border border-ll-bone/40 px-4 py-2 font-tech text-[11px] tracking-[0.2em] transition-colors duration-200 hover:bg-ll-red hover:border-ll-red hover:text-ll-bone"
        >
          ADD +
        </motion.button>
      </div>
      <span className="mt-2 block h-px w-0 bg-ll-red transition-all duration-300 group-hover:w-full" aria-hidden="true" />
    </motion.article>
  );
}
